<script lang="ts" setup>
import { ref } from 'vue'

import { t } from '@/locales/i18n'
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'
import type { GwFloatMethods } from '@/components/lib/GwFloat/GwFloat.vue'

export interface BtnClipboard {
  copiedTooltip?: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  tooltip?: string
  clipboard?: string
  copyUrl?: boolean
}

const props = withDefaults(defineProps<BtnClipboard>(), {
  placement: 'top',
  tooltip: t('messages.copy_to_clipboard'),
  copiedTooltip: t('messages.copied_to_clipboard'),
})

defineOptions({
  inheritAttrs: false,
})

const copied = ref(false)
const tooltipCont = ref()

let timeout: ReturnType<typeof setTimeout>
const resetTimeout = () => {
  clearTimeout(timeout)
  copied.value = false
}
const handleClick = (e: Event, methods: GwFloatMethods) => {
  resetTimeout()
  const text = props.copyUrl ? window.location.href : props.clipboard
  navigator.clipboard.writeText(`${text}`)

  methods.open(e)
  copied.value = true
  timeout = setTimeout(() => {
    methods.close()
    copied.value = false
  }, 2000)
}
</script>

<template>
  <GwTooltipNew
    ref="tooltipCont"
    :placement
    :tooltip="copied ? copiedTooltip : tooltip"
    :variant="copied ? 'primary' : ''"
    @close="resetTimeout"
  >
    <template #opener="{ listeners, methods }">
      <div
        class="gw_btn weight_500 text-medium"
        v-bind="$attrs"
        style="min-height: 2rem"
        v-on="listeners"
        @click.stop="handleClick($event, methods)"
      >
        <div
          class="mdi mdi-link mr-1"
          style="font-size: 1.25em"
        ></div>
        {{ t('btn.copy_url') }}
      </div>
    </template>
  </GwTooltipNew>
</template>
